// extracted by mini-css-extract-plugin
module.exports = {"primary":"PrimaryButton_primary__15uY3"};